/**
 * Browser navigation as an isolated side effect, so the auth flow's logic stays unit-testable.
 * Excluded from unit coverage like `main.tsx` (jsdom cannot navigate); the Playwright E2E layer
 * exercises the real redirect. The shop's checkout redirect reuses it for the same reason.
 */
export function navigate(url: string): void {
  window.location.assign(url);
}
